

import { Route, Routes } from 'react-router-dom';
import './fonts.css';
import './index.css';

// Components
import { ScrollToTop } from './components/ScrollToTop';

// Page Components
import { HomePage } from './pages/HomePage';
import { LeadershipPage } from './pages/LeadershipPage';
import { ServicesPage } from './pages/ServicesPage';

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/leadership" element={<LeadershipPage />} />
      </Routes>
    </>
  );
}

export default App;


